import React from 'react';
import Text from '../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './WorkplaceDoctorStatisticsTable.module.scss';

interface Props {
	value: string | null;
}

const WorkplaceDoctorStatisticsTableItem: React.FC<Props> = ({ value }) => {
	const renderValue = value ?? '-';
	return <Text tx={renderValue} className={styles.item} />;
};

export default WorkplaceDoctorStatisticsTableItem;
